import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      stateOptions: [
        {
          'text': 'Alabama - AL',
          'value': 'AL',
        },
        {
          'text': 'Alaska - AK',
          'value': 'AK',
        },
        {
          'text': 'American Samoa - AS',
          'value': 'AS',
        },
        {
          'text': 'Arizona - AZ',
          'value': 'AZ',
        },
        {
          'text': 'Arkansas - AR',
          'value': 'AR',
        },
        {
          'text': 'California - CA',
          'value': 'CA',
        },
        {
          'text': 'Colorado - CO',
          'value': 'CO',
        },
        {
          'text': 'Connecticut - CT',
          'value': 'CT',
        },
        {
          'text': 'Delaware - DE',
          'value': 'DE',
        },
        {
          'text': 'District Of Columbia - DC',
          'value': 'DC',
        },
        {
          'text': 'Federated States Of Micronesia - FM',
          'value': 'FM',
        },
        {
          'text': 'Florida - FL',
          'value': 'FL',
        },
        {
          'text': 'Georgia - GA',
          'value': 'GA',
        },
        {
          'text': 'Guam - GU',
          'value': 'GU',
        },
        {
          'text': 'Hawaii - HI',
          'value': 'HI',
        },
        {
          'text': 'Idaho - ID',
          'value': 'ID',
        },
        {
          'text': 'Illinois - IL',
          'value': 'IL',
        },
        {
          'text': 'Indiana - IN',
          'value': 'IN',
        },
        {
          'text': 'Iowa - IA',
          'value': 'IA',
        },
        {
          'text': 'Kansas - KS',
          'value': 'KS',
        },
        {
          'text': 'Kentucky - KY',
          'value': 'KY',
        },
        {
          'text': 'Louisiana - LA',
          'value': 'LA',
        },
        {
          'text': 'Maine - ME',
          'value': 'ME',
        },
        {
          'text': 'Marshall Islands - MH',
          'value': 'MH',
        },
        {
          'text': 'Maryland - MD',
          'value': 'MD',
        },
        {
          'text': 'Massachusetts - MA',
          'value': 'MA',
        },
        {
          'text': 'Michigan - MI',
          'value': 'MI',
        },
        {
          'text': 'Minnesota - MN',
          'value': 'MN',
        },
        {
          'text': 'Mississippi - MS',
          'value': 'MS',
        },
        {
          'text': 'Missouri - MO',
          'value': 'MO',
        },
        {
          'text': 'Montana - MT',
          'value': 'MT',
        },
        {
          'text': 'Nebraska - NE',
          'value': 'NE',
        },
        {
          'text': 'Nevada - NV',
          'value': 'NV',
        },
        {
          'text': 'New Hampshire - NH',
          'value': 'NH',
        },
        {
          'text': 'New Jersey - NJ',
          'value': 'NJ',
        },
        {
          'text': 'New Mexico - NM',
          'value': 'NM',
        },
        {
          'text': 'New York - NY',
          'value': 'NY',
        },
        {
          'text': 'North Carolina - NC',
          'value': 'NC',
        },
        {
          'text': 'North Dakota - ND',
          'value': 'ND',
        },
        {
          'text': 'Northern Mariana Islands - MP',
          'value': 'MP',
        },
        {
          'text': 'Ohio - OH',
          'value': 'OH',
        },
        {
          'text': 'Oklahoma - OK',
          'value': 'OK',
        },
        {
          'text': 'Oregon - OR',
          'value': 'OR',
        },
        {
          'text': 'Palau - PW',
          'value': 'PW',
        },
        {
          'text': 'Pennsylvania - PA',
          'value': 'PA',
        },
        {
          'text': 'Puerto Rico - PR',
          'value': 'PR',
        },
        {
          'text': 'Rhode Island - RI',
          'value': 'RI',
        },
        {
          'text': 'South Carolina - SC',
          'value': 'SC',
        },
        {
          'text': 'South Dakota - SD',
          'value': 'SD',
        },
        {
          'text': 'Tennessee - TN',
          'value': 'TN',
        },
        {
          'text': 'Texas - TX',
          'value': 'TX',
        },
        {
          'text': 'Utah - UT',
          'value': 'UT',
        },
        {
          'text': 'Vermont - VT',
          'value': 'VT',
        },
        {
          'text': 'Virgin Islands - VI',
          'value': 'VI',
        },
        {
          'text': 'Virginia - VA',
          'value': 'VA',
        },
        {
          'text': 'Washington - WA',
          'value': 'WA',
        },
        {
          'text': 'West Virginia - WV',
          'value': 'WV',
        },
        {
          'text': 'Wisconsin - WI',
          'value': 'WI',
        },
        {
          'text': 'Wyoming - WY',
          'value': 'WY',
        },
      ],
    };
  },
});
